import { useParams } from 'react-router-dom';

/** Numeric `:id` of the current detail route. */
export const useRouteId = () => Number(useParams().id);
